export default {
  title: 'Audio',
  input: 'Input',
  microphone: 'Microphone',
  autoAdjustMicLevel: 'Automatically adjust my mic level',
  output: 'Output',
  speakerSource: 'Speaker source',
  speakerVolume: 'Speaker volume',
  ringtoneSource: 'Ringtone and notification source',
  ringtoneVolume: 'Ringtone and notification volume',
  ringtones: 'Ringtones',
  noDevices: 'No devices',
  off: 'Off',
  noLabel: 'Unknown device',
  stopRecordDescription:
    'Say something to check your mic level ({countDown} sec)',
  stopPlaybackDescription: 'Playing your recording...',
  startRecordButton: 'Test microphone',
  stopRecordButton: 'Stop recording',
  stopPlaybackButton: 'Stop test',
  startTestButton: 'Test speaker',
  stopTestDescription: 'Playing sample sound...',
} as const;
